import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorHandle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 18,
	viewBox: "0 0 12 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6 -2.62268e-07C9.31371 -1.17422e-07 12 2.68629 12 6L12 12C12 15.3137 9.31371 18 6 18V18C2.68629 18 4.58723e-08 15.3137 1.90719e-07 12L4.52987e-07 6C5.97834e-07 2.68629 2.68629 -4.07115e-07 6 -2.62268e-07V-2.62268e-07V-2.62268e-07Z" }), /* @__PURE__ */ _jsx("rect", {
		opacity: .99,
		x: 9.5,
		y: 8.5,
		width: 7,
		height: 7,
		rx: 3.5,
		transform: "rotate(90 9.5 8.5)",
		fill: "currentColor",
		stroke: "black"
	})]
});
export default SvgColorHandle;
